// extracted by mini-css-extract-plugin
export default {"container":"Home_container__9lQ33","shorterNavbar":"Home_shorterNavbar__PlPXa"};